import { SnRouteConfig } from '@lib/state/router';
import { SnBadgeConfig } from '@lib/ui/badge';
import { SnIconConfig } from '@lib/ui/icon';

import { SnMenuItemClickHandler } from './menu-item-click-handler.type';
import { SnMenuItemDisableExpression } from './menu-item-disable-expression.type';
import { SnMenuItemHideExpression } from './menu-item-hide-expression.type';

interface ISnMenuItemConfig<D = undefined> {
  label: string | (() => string);
  badge?: SnBadgeConfig;
  icon?: SnIconConfig;
  route?: SnRouteConfig;
  click?: SnMenuItemClickHandler<D>;
  hidden?: boolean | SnMenuItemHideExpression<D>;
  disabled?: boolean | SnMenuItemDisableExpression<D>;
}

export type SnMenuItemConfig<D = any> = ISnMenuItemConfig<D>;
